import Select from "react-select";

export const ReactSelect = ({
    label = "",
    options = [],
    value = null,
    onChange,
    name,
    placeholder = "Select Option",
    isMulti = false,
    isClearable = true,
    isDisabled = false,
    error = "",
    className = "",
}) => {

    return (
        <div className={`w-100 ${className}`}>

            {label && (
                <label className="mb-1 fw-semibold">
                    {label}
                </label>
            )}

            <Select
                options={options}
                value={value}
                name={name}
                onChange={onChange}
                placeholder={placeholder}
                isMulti={isMulti}
                isClearable={isClearable}
                isDisabled={isDisabled}
                styles={{
                    container: (base) => ({
                        ...base,
                        padding:'0px'
                    }),
                    control: (base, state) => ({
                        ...base,
                        minHeight: "45px",
                        borderRadius: "8px",
                        borderColor: error
                            ? "red"
                            : state.isFocused
                            ? "#86b7fe"
                            : "#ced4da",
                        boxShadow: "none",
                        "&:hover": {
                            borderColor: "#86b7fe",
                        },
                    }),

                    menu: (base) => ({
                        ...base,
                        zIndex: 9999,
                    }),
                }}
            />

            {error && (
                <small className="text-danger">
                    {error}
                </small>
            )}

        </div>
    );
};